import Vue from 'vue'
import Vuex from 'vuex'
import user from './vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user // 注册带命名空间的模块
  }
})